/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_Order_Loading_MoreInputs */

const vi_reconcile_order_loading_more = /** @type {(inputs: Reconcile_Order_Loading_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải thêm...`)
};

/**

* @param {Reconcile_Order_Loading_MoreInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_order_loading_more = /** @type {((inputs?: Reconcile_Order_Loading_MoreInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_Order_Loading_MoreInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_order_loading_more(inputs)
});